// General
import PropTypes from 'prop-types';
import React, { Component } from 'react';
// Redux Form
import { reduxForm } from 'redux-form';
// Redux
import { connect } from 'react-redux';
// Translation
import { injectIntl } from 'react-intl';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import {
  FormGroup
} from 'react-bootstrap';

// Internal Component
import PhotosUpload from '../PhotosUpload';
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import stepFiveIllustration from '/public/SiteImages/step5.svg';

import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';

// Locale
import messages from '../../locale/messages';
// Validate
import updateStep2 from './updateStep2';
// Helpers
import validateStep2 from './validateStep2';


class Photos extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    listId: PropTypes.number.isRequired,
    photosCount: PropTypes.number,
  };

  render() {
    const { error, handleSubmit, submitting, dispatch, nextPage, previousPage, listId, formPage, step, photosCount } = this.props;
    const { formatMessage } = this.props.intl;
    const isDisabled = photosCount < 5;
    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            title={`Agrega algunas \n`}
            highlightText="fotos de tu espacio"
            subtitle="Para empezar necesitarás al menos 5 fotos. Te recomendamos subir al menos 1 foto de cada espacio que tengas (incluye dormitorios, baños, sala, entre otros)"
            iconImg={stepFiveIllustration}
          />
          <form>
            <div className={s.stepRightCard}>
              <div className={s.landingMainContent} style={{ padding: 0, display: 'flex', flexDirection: 'column', flex: 1 }}>
                <FormGroup className={s.formGroup} style={{ margin: 0, flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <PhotosUpload listId={listId} placeholder={formatMessage(messages.photosPlaceholder)} />
                </FormGroup>
              </div>
              <FooterButton
                nextPage={nextPage}
                previousPage={previousPage}
                previousPagePath={"amenities"}
                nextPagePath={"review-photos"}
                isDisabled={isDisabled}
                formPage={formPage}
                step={step}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

Photos = reduxForm({
  form: 'ListPlaceStep2', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  keepDirtyOnReinitialize: true,
  onSubmit: updateStep2,
  validate: validateStep2,
})(Photos);

const mapState = (state) => ({
  photosCount: state.location.photosCount
});
const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Photos)));